import { render, staticRenderFns } from "./TabPrognoses.vue?vue&type=template&id=6f31046a"
import script from "./TabPrognoses.vue?vue&type=script&lang=js"
export * from "./TabPrognoses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports